import { Controller } from "@hotwired/stimulus";
import { buildUploadComponent, filesCountChangedEventName } from '../../scripts/fileUpload';
import { viewOrEditFormConnectedEventName } from "../ViewOrEditForm/ViewOrEditFormController";

export default class AudioEditorController extends Controller {
    static targets = [
        "audioUploader",
        "shouldAutoGenerateTtsAudio"
    ];

    readonly audioUploaderTarget!: HTMLElement;
    readonly shouldAutoGenerateTtsAudioTarget!: HTMLInputElement;

    connect() {
        this.element.addEventListener(filesCountChangedEventName, this.onAudioFilesCountChanged.bind(this), {});

        this.element.addEventListener(viewOrEditFormConnectedEventName, () => {
            buildUploadComponent($(this.audioUploaderTarget));
        });
    }

    onAudioFilesCountChanged(event: CustomEventInit) {
        const audioFilesCount = event.detail as number;
        this.shouldAutoGenerateTtsAudioTarget.checked = audioFilesCount === 0;
    }
}